module.exports = __webpack_public_path__ + "static/media/commit.05b02d04.svg";